export default __webpack_public_path__ + "/image/peprmint_logo_e67e17c.svg";